import {
  ChangeDetectorRef, ChangeDetectionStrategy, Component, EventEmitter, Input, Output,
  OnInit, OnDestroy, ViewChild,
} from '@angular/core';
import { Observable ,  BehaviorSubject } from 'rxjs';
import * as _ from 'lodash';

import { SearchModel } from 'shared/search/search.model';
import { columns } from './columns';

import { ActiveFilterModel } from 'shared/search/active-filters/active-filter.model';
import { LIST_FILTER_TYPE } from 'shared/search/active-filters/active-filter-types';

import { SearchWidgetComponent } from 'shared/search-widget/search-widget.component';
import { LoaderComponent } from 'shared/loader/loader.component';

import { BrandService } from 'shared/brand/brand.service';
import { DigitalAssetsSearchService } from '../../../../digital-assets/search/digital-assets-search.service';
import {ProductPanelComponent} from '../../../../product-panel/product-panel.component';


@Component({
  moduleId: module.id,
  selector: 'assets-search',
  templateUrl: 'assets-search.component.html',
  styleUrls: ['assets-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetsSearchComponent extends SearchWidgetComponent implements OnInit, OnDestroy {

  @Output() openLists: EventEmitter<any> = new EventEmitter();

  @ViewChild(LoaderComponent, {static: false})
  loader: LoaderComponent | void;

  columns = columns;

  constructor(
    public searchService: DigitalAssetsSearchService,
    protected brandService: BrandService,
    private ref: ChangeDetectorRef,
  ) {
    super(
      brandService,
      searchService,
    );
  }

  ngOnInit() {
    this.searchModel = new SearchModel();
  }

  ngOnDestroy() {
    this.destroySubscriptions();
  }

  onListIconClick() {
    this.openLists.emit();
  }

  public startSearch(): void {
    if (!this.searchModelSub) {
      this.initSubscriptions();
    } else {
      if (this.searchModel instanceof SearchModel) {
        this.runSearch(this.searchModel);
      }
    }
  }

  public resetData(): void {
    this.searchService.deselectAll();
    this.searchService.searchResults = [];
    this.searchModel = new SearchModel();
  }

  public runSearch(searchModel: SearchModel) {
    if (this.loader instanceof LoaderComponent) {
      this.loader.show();
    }
    this.ref.markForCheck();
    this.searchService.runSearch(this.brandService.getBrand(), searchModel)
    .subscribe((res: any) => {
      if (this.loader instanceof LoaderComponent) {
        this.loader.hide();
      }
      this.ref.markForCheck();
    });
  }

  public searchByTerm(searchTerm: string): void {
    if (this.searchModel instanceof SearchModel) {
      this.searchModel.searchValue = searchTerm;
      this.searchModel.currentPage = 1;
    }
    this.searchService.allSelected = false;
    if (this.searchModel instanceof SearchModel) {
      this._searchModel.next(this.searchModel);
    }
  }

  public searchByList(selectedList: any): void {
    if (selectedList.selected) {
      const filter = new ActiveFilterModel(
        selectedList._id,
        selectedList.name,
        LIST_FILTER_TYPE
      );
      if (this.searchModel instanceof SearchModel) {
        this.searchModel.filters = [filter];
      }
    } else {
      if (this.searchModel instanceof SearchModel) {
        this.searchModel.filters = [];
      }
    }
    if (this.searchModel instanceof SearchModel) {
      this._searchModel.next(this.searchModel);
    }
  }

  /*
    * Add already assigned assets to the selected items list
    * Thus they are checked in the search results
   */
  public setAssignedAssets(assignedAssets: Array<any>): void {
    this.searchService.clearSelectedItems();
    this.searchService.pushSelectedItems(assignedAssets);
  }
}
